import $ from 'jquery';

export default function hideShowSuImageHeadingStraplineBackground() {
    var $suImage = $('.su-image'),
        $suImageHeading = $('.su-image-heading'),
        $suImageStrapline = $('.su-image-strapline');

    $($suImage).on('mouseover', function() {
        $(this).find($suImageHeading).has('a').parent().addClass('su-image-is-hover');
        $(this).find($suImageStrapline).has('a').parent().addClass('su-image-is-hover');
    });

    $($suImage).on('mouseout', function() {
        $(this).find($suImageHeading).has('a').parent().removeClass('su-image-is-hover');
        $(this).find($suImageStrapline).has('a').parent().removeClass('su-image-is-hover');
    });
}
